export default "__VITE_ASSET__C64SIgdu__"